<template>
  <el-tabs stretch v-model="selectedTab">
    <el-tab-pane label="Ảnh/Video" name="1">
      <ImageVideoTab :key="conversation.accountId + conversation.toId" :conversation="conversation" />
    </el-tab-pane>
    <el-tab-pane label="Files" name="2">
      <FileTab :key="conversation.accountId + conversation.toId" :conversation="conversation" />
    </el-tab-pane>
    <el-tab-pane label="Links" name="3">
      <LinkTab :key="conversation.accountId + conversation.toId" :conversation="conversation" />
    </el-tab-pane>
  </el-tabs>


</template>

<script>
import ImageVideoTab from "./ImageVideoTab";
import FileTab from "./FileTab";
import LinkTab from "./LinkTab";

export default {
  components: { LinkTab, FileTab, ImageVideoTab },
  props: ["conversation"],
  data() {
    return {
      selectedTab: "1",
      showFileTab: false
    };
  },
  methods: {}
};
</script>

<style scoped>

</style>